import { isEmpty } from "lodash";
import { DEVICE_TYPES, ENABLED, EXTRACT_TEXT_VIEW, MARKUP_VIEW, ZOOM_LEVEL_LIST, ZOOM_LEVEL_VALUE } from "../constants/Constants";
import { NOTIFICATION_TYPES } from "../constants/DataTrackNotificationConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import { dualStreamEnabled, isAgentIdentity } from "../shared/utility";
import reduxStore from "../configureEnvStore";
import { setCurrentZoom } from "../reducers/common-reducer";
import { expandViewEnabled, isLocalUserStreaming, isParticipantStreaming, isvideoenabled } from "../components/Twilio/Room/roomFunction";
import { LogFirebase } from "./firestore";
import { setStreamingDetails } from "../reducers/twilioEvents-reducer";
import googleEvent from "./googleEvent";
import { handleLivepointerOnZoom } from "../components/LivePointer/LivePointerUtils";
import { isScreenShareAvailable } from "../components/Twilio/ScreenShare/ScreenShareUtils";
import { EVENT_NAME, EXTRA_PARAM_NAME } from "../constants/GTagConstants";
import { sendDataTrack } from "../shared/dataTrackFunction";
import arMarkupService from "./MarkupService/arMarkupService";
class ZoomService {
    disablepinchOnmarkup = false;

    /* Handle to send data track to the remote user */
    sendZoomLevelMsg = (from) => {
        let notiType = NOTIFICATION_TYPES.ZOOM_LEVEL.GUEST_TO_AGENT;
        if (GLOBAL_MEETING_DATA.isAgent) {
            notiType = NOTIFICATION_TYPES.ZOOM_LEVEL.AGENT_TO_GUEST;
        }
        //send data track
        let ZoomLevelMessagePayload = {
            notification_type: notiType,
            device_type: GLOBAL_MEETING_DATA.device_type,
            identity: CALL_DATA.localIdentity,
            zoomLevel: reduxStore.getState().commonReducer.currentZoom,
            zoomStatus: "1",
        };
        if (from) {
            /** send zoom level for manual click only 
                if streaming identity was web/mweb and point is on
            **/
            ZoomLevelMessagePayload.isManual = "1";
            handleLivepointerOnZoom();
        } else {
            ZoomLevelMessagePayload.isManual = "0";
        }
        sendDataTrack(ZoomLevelMessagePayload);
        LogFirebase("Zoom", "send_msg", {
            zoomlLevel: ZoomLevelMessagePayload.zoomLevel,
            status: ZoomLevelMessagePayload.zoomStatus,
            notiType: ZoomLevelMessagePayload.notification_type,
            identity: ZoomLevelMessagePayload.identity,
        });
    };

    /* All done */
    toggleZoomHandler = (zoomValIndex, zoomStatus, isManual, msgIdentity) => {
        reduxStore.dispatch(setCurrentZoom(zoomValIndex));
        const zoomVal = ZOOM_LEVEL_VALUE[zoomValIndex];
        if (zoomStatus !== undefined && zoomStatus === "1") {
            if (zoomValIndex > 0) {
                setTimeout(() => {
                    this.cssZoom(parseFloat(1) + 0.1 * zoomVal);
                }, 500);
            } else {
                this.resetZoom();
            }
        } else {
            //zoom disabled - when app goes i bkground or flip camera
            this.resetZoom(zoomStatus, msgIdentity);
        }
        if (isManual) {
            this.sendZoomLevelMsg(isManual);
            // send zoom event log for google analytic
            const device_type = reduxStore.getState().twilioEvents.streamingDetails.device_type;
            if (device_type) {
                if (
                    device_type !== DEVICE_TYPES.ANDROID_BROWSER &&
                    device_type !== DEVICE_TYPES.DESKTOP &&
                    device_type !== DEVICE_TYPES.IOS_BROWSER
                ) {
                    googleEvent.logEvent(EVENT_NAME.ZOOM_BY_AGENT, EXTRA_PARAM_NAME.ZOOM_VALUE, zoomVal);
                }
            }
        }
    };

    /* Reset Zoom for local user */
    resetZoom = (zoomStatus, msgIdentity) => {
        reduxStore.dispatch(setCurrentZoom(ZOOM_LEVEL_LIST.ONE));
        setTimeout(() => {
            this.cssZoom(ZOOM_LEVEL_LIST.ONE);
        }, 500);
        if (zoomStatus !== undefined && zoomStatus === "2") {
            const streamingIdentity = reduxStore.getState().twilioEvents.streamingPartiIdentity;
            if (msgIdentity !== undefined && streamingIdentity === msgIdentity) {
                LogFirebase("Zoom", "disabled_status", zoomStatus);
            } else {
                LogFirebase("Zoom", "enabled_status", zoomStatus);
            }
        } else {
            LogFirebase("Zoom", "enabled_status", "reset zoom");
        }
    };

    /* Zoom video functionality using CSS */
    cssZoom = (scalValue) => {
        const device_type = reduxStore.getState().twilioEvents.streamingDetails?.device_type || GLOBAL_MEETING_DATA.device_type;
        if (device_type === DEVICE_TYPES.ANDROID_BROWSER || device_type === DEVICE_TYPES.DESKTOP || device_type === DEVICE_TYPES.IOS_BROWSER) {
            const divtag = document.getElementById("expandedVideo");
            const videoTag = divtag?.getElementsByTagName("video")[0];
            if (videoTag) {
                videoTag.style.transform = `scale(${scalValue})`;
                LogFirebase("Zoom", "selected_zoom", scalValue);
            }
        }
    };

    /* Handle the Zoom based on data track for remote user */
    callToggleZoom = (message) => {
        if (!isAgentIdentity(message.identity)) {
            //if msg is from any guest
            if (dualStreamEnabled() && expandViewEnabled()) {
                if (!isParticipantStreaming(message.identity)) {
                    return false;
                }
            }
        }

        const { streamingDetails } = reduxStore.getState().twilioEvents;

        if (!streamingDetails) {
            reduxStore.dispatch(
                setStreamingDetails({
                    identity: message?.identity,
                    device_type: message?.device_type,
                })
            );
        }

        if (message?.isManual == "1") {
            handleLivepointerOnZoom();
        }
        this.toggleZoomHandler(message?.zoomLevel, message?.zoomStatus, false, message?.identity);
    };

    /* Reset Zoom and call that function unpublish video and video grid view */
    callResetZoom = () => {
        this.resetZoom();
        this.sendZoomLevelMsg();
    };

    /* Handle to show the video zoom button is show only when the guest video is on */
    /* Other conditions are pending to implement due to dependency */
    checkZoomButtonAvailable = () => {
        const extractTextInprogress = reduxStore.getState().extractText.extractTextInprogress;
        const ocrinprogress = extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW || extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW;
        const markupInprogress =
            reduxStore.getState().markup.markupInprogress === MARKUP_VIEW.PREPARE_VIEW ||
            reduxStore.getState().markup.markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW;
        const isArMarkupInProgress = arMarkupService.checkARMarkupIsOngoing();
        if (!isScreenShareAvailable()) {
            if (!markupInprogress && !ocrinprogress && !isArMarkupInProgress) {
                if (
                    (GLOBAL_MEETING_DATA.isAgent && !isLocalUserStreaming() && isvideoenabled()) ||
                    (!GLOBAL_MEETING_DATA.isAgent && isLocalUserStreaming())
                ) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        } else {
            return true;
        }
    };

    /* for Markup, OCR and Upload file */
    resetZoomLevelOnExitView = () => {
        if (PublicVariables.featureFlag?.SHOWMEZOOM === ENABLED) {
            const { streamingDetails } = reduxStore.getState().twilioEvents;
            if (!isEmpty(streamingDetails) && ![DEVICE_TYPES.ANDROID_APP, DEVICE_TYPES.IOS_APP].includes(streamingDetails?.device_type)) {
                reduxStore.dispatch(setCurrentZoom(ZOOM_LEVEL_LIST.ONE));
            }
        }
    };

    viewport = document.querySelector("meta[name=viewport]");
    disablePinchZoom = () => {
        this.viewport.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0");
    };

    enablePinchZoom = () => {
        this.viewport.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=4.0, user-scalable=yes");
    };

    resetPinchZoom = () => {
        this.viewport.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=4.0, user-scalable=yes");
    };
}

export default new ZoomService();
